import React, { useEffect, useState, useRef } from 'react';
import { customFetch } from '../apiClient';

const DiscountAuthorityForm = () => {
  const [form, setForm] = useState({ type: "", authority: "" });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [authorities, setAuthorities] = useState([]);

  // EDIT MODE STATES
  const [editId, setEditId] = useState(null);

  const formRef = useRef(null);

  useEffect(() => {
    loadAuthorities();
  }, []);

  const loadAuthorities = async () => {
    try {
     const res = await customFetch(`/DiscountAuthDt`);
      if (res.ok) setAuthorities(await res.json());
    } catch (err) {
      console.error(err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  // -----------------------
  // SAVE / UPDATE HANDLER
  // -----------------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); 
    setSuccess("");

    if (!form.type || !form.authority.trim()) {
      setError("Please fill Type and Authority Name.");
      return;
    }

    setLoading(true);

    try {
              const payload = {
            type: form.type,
            authority: form.authority.trim()
          };

          let res;

          if (editId) {
            // UPDATE API (PUT)
            res = await customFetch(`/DiscountAuthDt/${editId}`, {
              method: "PUT",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(payload)
            });
          } else {
            // ADD API (POST)
            res = await customFetch(`/DiscountAuthDt`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(payload)
            });
          }

      if (!res.ok) throw new Error(await res.text());

      setSuccess(editId ? "Authority Updated Successfully" : "Authority Added Successfully!");

      // RESET FORM
      setForm({ type: "", authority: "" });
      setEditId(null);

      loadAuthorities();

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // -----------------------
  // DELETE
  // -----------------------
  const deleteAuthority = async (id) => {
    if (!window.confirm("Delete this authority?")) return;

    try {
      const res = await customFetch(`/DiscountAuthDt/${id}`, {
  method: "DELETE"
});

      if (!res.ok) throw new Error(await res.text());

      setSuccess("Deleted Successfully");
      loadAuthorities();

    } catch (err) {
      setError(err.message);
    }
  };

  // -----------------------
  // LOAD DATA INTO FORM ON EDIT
  // -----------------------
  const startEdit = (item) => {
    setEditId(item.id);
    setForm({ type: item.type, authority: item.authority });
    setError(""); 
    setSuccess("");
  };

  const cancelEdit = () => {
    setEditId(null);
    setForm({ type: "", authority: "" });
  };

  return (
    <div className="container mt-4">
      <div className="card shadow">

        <div className="card-header py-2">
          <h6 className="fw-bold">
            {editId ? "Edit Discount Authority" : "Add Discount Authority"}
          </h6>
        </div>

        <div className="card-body">

          {error && <div className="alert alert-danger py-1">{error}</div>}
          {success && <div className="alert alert-success py-1">{success}</div>}

          {/* ------------------------
                ADD / EDIT FORM 
              ------------------------ */}
          <form ref={formRef} onSubmit={handleSubmit}>
            <div className="row g-3">

              <div className="col-md-4">
                <label className="small fw-semibold">Type *</label>
                <select
                  name="type"
                  value={form.type}
                  onChange={handleChange}
                  className="form-select form-select-sm"
                >
                  <option value="">Select</option>
                  <option value="Discount">Discount</option>
                  <option value="Doctor">Doctor</option>
                  <option value="Manager">Manager</option>
                  <option value="Admin">Admin</option>
                  <option value="Director">Director</option>
                  <option value="Owner">Owner</option>
                </select>
              </div>

              <div className="col-md-8">
                <label className="small fw-semibold">Authority *</label>
                <input
                  name="authority"
                  value={form.authority}
                  onChange={handleChange}
                  className="form-control form-control-sm"
                  placeholder="Dr. Sharma / Admin Manager"
                />
              </div>

            </div>

            <div className="text-end mt-3">

              {editId && (
                <button 
                  type="button" 
                  className="btn btn-secondary btn-sm me-2"
                  onClick={cancelEdit}
                >
                  Cancel Edit
                </button>
              )}

              <button className="btn btn-success btn-sm px-3" disabled={loading}>
                {loading ? "Saving..." : editId ? "Update Authority" : "Add Authority"}
              </button>

            </div>
          </form>

          {/* ------------------------
                TABLE LIST 
              ------------------------ */}

          <h6 className="mt-4">Authorities</h6>
          <div className="table-responsive">
            <table className="table table-bordered table-sm text-center">
              <thead>
                <tr>
                  <th>Sr</th>
                  <th>Type</th>
                  <th>Authority Name</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {authorities.map((a, index) => (
                  <tr key={a.id}>
                    <td>{index + 1}</td>
                    <td>{a.type}</td>
                    <td>{a.authority}</td>

                    <td>
                      <i
                        className="bi bi-pencil-square text-primary me-3"
                        style={{ cursor: "pointer" }}
                        onClick={() => startEdit(a)}
                      ></i>

                      <i
                        className="bi bi-trash text-danger"
                        style={{ cursor: "pointer" }}
                        onClick={() => deleteAuthority(a.id)}
                      ></i>
                    </td>

                  </tr>
                ))}
              </tbody>

            </table>
          </div>

        </div>
      </div>
    </div>
  );
};

export default DiscountAuthorityForm;
